export default "/operators"